import { createSlice } from '@reduxjs/toolkit';

// Initial state for subscription plans
const initialState = {
  subscriptions: [], // List of subscription plans
};

// Create a slice for subscription plans with reducers for set, delete, and edit
const subscriptionPlanSlice = createSlice({
  name: 'subscriptionPlan',
  initialState,
  reducers: {
    // Set the entire subscriptions list
    setSubscriptions(state, action) {
      state.subscriptions = action.payload;
    },
    // Delete a subscription by id
    deleteSubscription(state, action) {
      state.subscriptions = state.subscriptions.filter(
        (sub) => sub.id !== action.payload
      );
    },
    // Edit/update a subscription by id
    editSubscription(state, action) {
      const index = state.subscriptions.findIndex(
        (sub) => sub.id === action.payload.id
      );
      if (index !== -1) {
        state.subscriptions[index] = { ...state.subscriptions[index], ...action.payload };
      }
    },
    // Add a new subscription plan
    addSubscription(state, action) {
      state.subscriptions.push(action.payload);
    },
  },
});

// Export actions for use in components
export const { setSubscriptions, deleteSubscription, editSubscription, addSubscription } = subscriptionPlanSlice.actions;

// Export reducer for store configuration
export default subscriptionPlanSlice.reducer;
